<template lang="pug">
component.search-pagination__number(
  v-if="isNumberVisible",
  @click="goToPage(index)",
  :is="type"
) {{ number }}
span.search-pagination__ellipsis(v-else-if="isEllipseVisible")
</template>

<script>
export default {
  name: "BluePaginationItem",
  props: ["index", "number", "goToPage", "isActive", "isNumber", "isEllipsis"],
  computed: {
    type() {
      return this.isActive(this.index) ? "span" : "button";
    },
    isNumberVisible() {
      return this.isNumber(this.index);
    },
    isEllipseVisible() {
      return this.isEllipsis(this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-pagination__number {
  @include fluid(width, 1.375rem, 3.125rem);
  @include fluid(height, 1.375rem, 3.125rem);
  @include fluid(font-size, 0.875rem, 1.125rem);
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 0;
  margin: 0;
  appearance: none;
  color: var(--pagination-number-color);
  background: var(--pagination-number-background);
  transition: var(--pagination-nav-transition);
  border: none;
  border-radius: 0;
  flex: 0 0 auto;

  &:is(span) {
    color: var(--pagination-number-active-color);
    background: var(--pagination-number-active-background);
  }

  &:is(button) {
    cursor: pointer;

    &:hover {
      color: var(--pagination-number-hover-color);
      background: var(--pagination-number-hover-background);
    }
  }
}

.search-pagination__ellipsis {
  @include fluid(width, 1.375rem, 3.125rem);
  @include fluid(min-width, 1.375rem, 3.125rem);
  @include fluid(height, 1.375rem, 3.125rem);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: var(--pagination-number-color);
  font-size: 0.125rem;
  flex: 0 0 auto;

  &::after {
    content: "";
    height: 1em;
    width: 1em;
    background: currentColor;
    border-radius: 50%;
    opacity: 0.5;
    box-shadow: 0.25rem 0 0 currentColor, -0.25rem 0 0 currentColor;
  }
}
</style>